import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';

//TODO: check how to handle translation for Date

export type NestedTranslation = {
    [key: string]: string | NestedTranslation;
};

export const defaultTranslation = 'en-us';

// Initialize i18next
i18n.use(initReactI18next).init({
    debug: false,
    resources: {
        [defaultTranslation]: { translation: en },
    },
    lng: defaultTranslation,
    fallbackLng: defaultTranslation,
    lowerCaseLng: true,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
